<template>
	<AppSelect
		dense
		outlined
		hide-details
		item-text="text"
		item-value="value"
		v-model="progressBarMode"
		class="slct set width-100"
		:items="PROGRESS_BAR_OPTIONS"
		append-icon="fa fa-chevron-down"
	/>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { ProgressBarSettings } from '@ply-io/ply-front-shared-utilities';

import { updateWorkflowSetting } from '@/store/modules/selectedWorkflow/actions.js';
import { getWorkflowAppearanceSettings } from '@/store/modules/selectedWorkflow/getters.js';
import { PROGRESS_BAR_OPTIONS } from '@/utils/workflow-service.const';

export default {
	name: 'FeatureProgressBarSettings',
	components: {},
	computed: {
		...mapGetters([getWorkflowAppearanceSettings.fullPath]),
		workflowAppearanceSettings() {
			return this[getWorkflowAppearanceSettings.fullPath];
		},
		progressBarMode: {
			set(value) {
				this.updateWorkflowVersionSettings({ key: 'progress_bar', value });
			},
			get() {
				return this.workflowAppearanceSettings.progress_bar || ProgressBarSettings.Simple;
			},
		},
	},
	methods: {
		...mapActions([updateWorkflowSetting.fullPath]),
		updateWorkflowVersionSettings(payload) {
			this[updateWorkflowSetting.fullPath](payload);
		},
	},
	data() {
		return { PROGRESS_BAR_OPTIONS };
	},
};
</script>
<style scoped lang="scss"></style>
